import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_SAL_ISU_REG_004_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();

    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let selectedHeader: any[] =
          gridRefs.current["grid1"].current?.getCheckedRows();

        let isSameCust: boolean = false;
        if (selectedHeader && selectedHeader.length > 0) {
          const cdCustValue = selectedHeader[0].cd_cust; // 외주처
          isSameCust = selectedHeader.every(
            (item: any) => item.cd_cust === cdCustValue
          );
        } else {
          return true;
        }

        if (!isSameCust) {
          await showDialog("alter", "거래처가 동일한 건만 적용 가능합니다.");
          return false;
        } else {
          return true;
        }
      },
      getOkayData: () => {
        return {
          rtnData: [
            gridRefs.current["grid1"].current?.getCheckedRows() || [],
            gridRefs.current["grid2"].current?.getCheckedRows() || [],
          ],
        };
      },
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_SAL_ISU_REG_004_POP_001", {});
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData);
          setFormData(mergedData);
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
          gridRefs.current["grid1"].current.selectAndFocusRow(0);
        } catch (error) {}
      };
      fetchform();
    }, []);

    const onSearch = async () => {
      try {
        const param = {
          id: "sn_sal_isu_reg_004_pop_01_01",
          params: searchRef.current.getFormdata(),
        };

        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0] || [],
          grid2: data[1] || [],
        });
        gridRefs.current["grid1"].current.resetUpdate();
        gridRefs.current["grid2"].current.resetUpdate();
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };

    const onFocusedRowChanged1 = (event: any) => {
      if (event) gridRefs.current["grid2"].current.selectAndFocusRow(0);
    };

    const onCheckedRowChaged1 = (
      value: boolean,
      type: "row" | "header" = "row"
    ) => {
      if (type === "header") {
        gridRefs.current["grid2"].current.setCheckedAll(value);
      } else {
        gridRefs.current["grid2"].current.setCheckedAllWithFilter(value);
      }
    };

    const onCheckedRowChaged2 = (value: boolean) => {
      const checkdRows =
        gridRefs.current["grid2"].current.getCheckedFilteredRows();
      if (checkdRows.length > 0)
        gridRefs.current["grid1"].current.setCheckedFocusedRow(true, "noEvent");
      else
        gridRefs.current["grid1"].current.setCheckedFocusedRow(
          false,
          "noEvent"
        );
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged: onFocusedRowChanged1,
            onCheckedRowChaged: onCheckedRowChaged1,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCheckedRowChaged: onCheckedRowChaged2,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>
        <div className="mb-2" style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div className="flex-1 flex flex-col gap-2 min-h-00">
          <div className="flex-1 min-h-0">
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{
                rowSelection: "multiple",
                ischeckboxSelection: true,
              }}
              events={grids.grid1.events}
              filter={{
                refs: [gridRefs.current["grid2"]],
                columns: ["cd_cust"],
              }}
            />
          </div>
          <div className="flex-1 min-h-10">
            <SnGrid
              ref={gridRefs.current["grid2"]}
              columnConfig={grids.grid2.columns}
              rowData={grids.grid2.dataSource}
              etcProps={{
                rowSelection: "multiple",
                ischeckboxSelection: true,
              }}
              events={grids.grid2.events}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default SN_SAL_ISU_REG_004_POP_001;
